/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { Button } from "components/ui/button";
import { Form, FormField, FormItem, FormMessage } from "components/ui/form";
import { queryClient } from "@/config/query-client";
import {
  useSaveTransactionReversalMutation,
  useUpdateTransactionReversalMutation,
} from "@/services/transactionReversal";
import { toast } from "components/ui/use-toast";
import { useForm } from "react-hook-form";
import { Input } from "components/ui/input";

export function ModalTransactionReversal({
  dataMCX002,
  dataMCX008,
  setLoading,
}: {
  dataMCX002: any;
  dataMCX008: any;
  setLoading?: any;
}) {
  const { handleModal } = useDialogModal();
  const form = useForm({
    defaultValues: {
      observation: "",
    },
  });

  const [updateTransactionReversal, { isError, isLoading: isLoadingUpdate }] =
    useUpdateTransactionReversalMutation();
  const [saveTransactionReversal, { isLoading }] =
    useSaveTransactionReversalMutation();

  const load = isLoading || isLoadingUpdate;

  const handleSubmit = async (data: { observation: string }) => {
    try {
      const updatedDataMCX008 = {
        ...dataMCX008,
        ...(data.observation ? { observation: data.observation } : {}),
      };

      const response = await updateTransactionReversal({
        data: dataMCX002,
      }).unwrap();

      if (isError) {
        throw new Error(response.message || "Erro ao atualizar transação");
      }

      queryClient.invalidateQueries(["transactionReversal"]);

      await saveTransactionReversal({ data: updatedDataMCX008 }).unwrap();

      toast({
        variant: "default",
        description: response.message,
        duration: 5000,
      });
    } catch (error) {
      toast({
        variant: "destructive",
        description:
          (error as any)?.data?.messages.join(", ") || "Erro ao estornar",
        duration: 5000,
      });
    } finally {
      handleModal({ isOpen: false });

      form.reset({
        observation: "",
      });

      setLoading(false);
    }
  };

  useEffect(() => {
    form.reset({
      observation: "",
    });
  }, [form]);

  return (
    <div className="grid gap-4">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <div className="space-y-4">
            <FormField
              control={form.control}
              name="observation"
              render={({ field }) => (
                <FormItem>
                  <Input
                    {...field}
                    hasError={!!form.formState.errors.observation}
                    name="observation"
                    placeholder="Observação"
                  />
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="flex w-full gap-4 justify-end">
              <button
                type="button"
                className="self-end w-max px-4 py-2 border border-black/20 flex items-center gap-2 rounded-md
                    text-black bg-white
                    transition-all duration-300 ease-in-out
                    hover:bg-[#2B0C1A] hover:text-white hover:border-transparent
                    "
                onClick={() => {
                  handleModal({
                    isOpen: false,
                  });
                }}
                disabled={isLoading}
              >
                Voltar
              </button>
              <Button type="submit" variant="default" isLoading={load}>
                Salvar
              </Button>
            </div>
          </div>
        </form>
      </Form>
    </div>
  );
}
